// Fallback for `data-turbo-confirm` when Turbo Drive is disabled.
//
// Every layout in this app sets `data-turbo="false"` on the body, which means
// Turbo never intercepts form submissions and therefore never honors
// `data-turbo-confirm`. Without this fallback, destructive `button_to`
// actions would submit silently — no confirmation dialog at all.
//
// This listener runs in the capture phase so it sees the submit before any
// other handler. If a confirm message is present (on the form or its
// submitter button) and the user cancels, we stop the submission entirely.
// If they accept, we mark the form as confirmed so we don't double-prompt
// in case Turbo Drive is later re-enabled on a specific form/scope.

const CONFIRMED_KEY = "_turboConfirmFallbackConfirmed";

function readConfirmMessage(form, submitter) {
  return (
    submitter?.getAttribute?.("data-turbo-confirm") ||
    form?.getAttribute?.("data-turbo-confirm") ||
    null
  );
}

function handleSubmit(event) {
  const form = event.target;
  if (!form || form.tagName !== "FORM") return;
  if (form.dataset[CONFIRMED_KEY] === "true") return;

  const message = readConfirmMessage(form, event.submitter);
  if (!message) return;

  if (!window.confirm(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  form.dataset[CONFIRMED_KEY] = "true";
}

export function installTurboConfirmFallback() {
  if (window.__turboConfirmFallbackInstalled) return;
  window.__turboConfirmFallbackInstalled = true;
  document.addEventListener("submit", handleSubmit, true);
}
